import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions';

const defaultState = {
  invoice: {},
  invoices: [],
  people: [],
  sites: [],
};

const reducer = handleActions(
  {
    [combineActions(actions.invoices.getInvoicesSuccess, actions.invoices.searchInvoicesSuccess)]: (
      state,
      { payload: { invoices } }
    ) => {
      return { ...state, invoices };
    },
    [combineActions(actions.invoices.getInvoiceByIdSuccess, actions.invoices.addInvoiceSuccess)]: (
      state,
      { payload: { invoice } }
    ) => {
      return { ...state, invoice, invoices: [...state.invoices.filter(i => i.id !== invoice.id), invoice] };
    },
  },
  defaultState
);

export default reducer;
